import { render, staticRenderFns } from "./BoletinesJudiciales.vue?vue&type=template&id=03abec54&lang=pug&"
import script from "./BoletinesJudiciales.vue?vue&type=script&lang=js&"
export * from "./BoletinesJudiciales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports